export default {

  name: 'OrganiserOverview',

  inject: [
    'organiserData'
  ],

  data () {
    return {
      currentOrganiser: null
    };
  }
};



// WEBPACK FOOTER //
// ./src/apps/booking/components/organiser/OrganiserOverview/OrganiserOverview.js